/**
 * Arabic for the boards: the ported dashboards, the airfield map, friction,
 * rubber, building plans, the 3D section, the instruments desk and the demo
 * chrome. Proposed; pending native aviation review.
 *
 * What the demo's own renderer writes (generated.ts) is not reached from here
 * and stays English.
 */
const ar: Record<string, string> = {
  /* ── chrome and toolbar ─────────────────────────────────────────────── */
  "GET THE FILE": "تنزيل الملف",
  CLOSE: "إغلاق",
  "AIRPORT FACILITIES": "مرافق المطار",
  "ALL FACILITIES": "جميع المرافق",
  BACK: "رجوع",
  "DEVELOPMENT MODE · SIGN-IN DISABLED · NOT FOR ANYBODY OUTSIDE THE BUILD · SET":
    "وضع التطوير · تسجيل الدخول معطّل · ليس لأحد خارج فريق البناء · اضبط",
  "BEFORE RELEASE": "قبل الإصدار",
  "Nothing on the drawing matches “{q}”.": "لا شيء في المخطط يطابق «{q}».",
  "Imported {n} work order(s).": "تم استيراد {n} من أوامر العمل.",
  "That file isn't a work order export.": "هذا الملف ليس تصديرًا لأوامر العمل.",
  "Find a work order or an asset": "ابحث عن أمر عمل أو أصل",
  "Type a work order id or an asset name, then press Enter": "اكتب رقم أمر العمل أو اسم الأصل، ثم اضغط Enter",
  Display: "العرض",
  DAYLIGHT: "نهاري",
  DARK: "داكن",
  "Download the work order register as JSON": "تنزيل سجل أوامر العمل بصيغة JSON",
  EXPORT: "تصدير",
  "Read a work order export back in": "استيراد ملف تصدير لأوامر العمل",
  IMPORT: "استيراد",

  /* ── board frames and views ─────────────────────────────────────────── */
  "DYNAMIC DASHBOARD": "لوحة المعلومات التفاعلية",
  "BUILDINGS & INFRASTRUCTURE": "المباني والبنية التحتية",
  REGISTER: "السجل",
  LOCATIONS: "المواقع",
  RECORDS: "السجلات",
  ENGINEERING: "الهندسة",
  MODULES: "الوحدات",
  "ACTIVITY LOG": "سجل النشاط",
  PROJECTS: "المشاريع",
  PORTFOLIO: "المحفظة",
  "ENGINEERING INSPECTIONS": "الفحوص الهندسية",
  "ASSESSMENTS & TESTING": "التقييمات والاختبارات",
  REPORTS: "التقارير",
  ANALYSIS: "التحليل",
  LANDSIDE: "الجانب الأرضي",
  "AIRPORT INSPECTION PLATFORM": "منصة فحص المطار",
  QUICK: "سريع",
  DETAILED: "مفصّل",
  PREDICT: "التنبؤ",
  KPI: "مؤشرات الأداء (KPI)",
  "FRICTION TEST REVIEW": "مراجعة اختبار الاحتكاك",
  SUMMARY: "الملخص",
  REVIEW: "المراجعة",
  COMPARE: "المقارنة",
  TREND: "الاتجاه",
  "RUBBER REMOVAL PLANNER": "مخطط إزالة المطاط",
  PLAN: "الخطة",
  HISTORY: "السجل التاريخي",
  ALERTS: "التنبيهات",
  "BUILDING PLANS": "مخططات المباني",
  "CLICK TWO POINTS A KNOWN DISTANCE APART": "انقر نقطتين تفصل بينهما مسافة معروفة",
  CANCEL: "إلغاء",
  "3D — LEVEL": "ثلاثي الأبعاد — الطابق",
  HEAT: "الكثافة",
  LIGHTS: "الأضواء",
  LABELS: "التسميات",
  "LOADING THE 3D VIEW…": "جارٍ تحميل العرض ثلاثي الأبعاد…",
  "THE 3D VIEW COULD NOT BE LOADED": "تعذّر تحميل العرض ثلاثي الأبعاد",
  "DRAG TO ORBIT · SCROLL TO ZOOM · TAP ANY OBJECT FOR DETAIL": "اسحب للدوران · مرّر للتكبير · انقر أي عنصر لتفاصيله",
  "Tap a light, sign, stand or work order pin. Symbols are drawn oversized so they can be seen across a 500 m section.":
    "انقر ضوءًا أو لوحة إرشادية أو موقف طائرة أو علامة أمر عمل. الرموز مرسومة بحجم كبير لتُرى عبر مقطع طوله 500 m.",

  /* ── the airfield map ───────────────────────────────────────────────── */
  "section {id} · {E} E {N} N": "المقطع {id} · {E} E {N} N",
  FIT: "ملاءمة",
  LANDSCAPE: "أفقي",
  PORTRAIT: "عمودي",
  "EXIT FULL SCREEN": "الخروج من ملء الشاشة",
  "FULL SCREEN": "ملء الشاشة",
  DRAWING: "المخطط",
  AIRFIELD: "الجانب الجوي",
  "REAL DAY": "واقعي نهارًا",
  "REAL NIGHT": "واقعي ليلًا",
  "REAL VIEW · PAINTED FROM THE RECORDS · TAXIWAY SURFACES, TAXIWAY LIGHTS, APPROACH LIGHTING, HOLD BARS AND PARKED AIRCRAFT ARE DERIVED":
    "عرض واقعي · مرسوم من السجلات · أسطح ممرات الطائرات وأضواؤها وإنارة الاقتراب وخطوط الانتظار والطائرات المتوقفة مستنتجة",
  "{n} CREW POSITION(S) LIVE FROM THE FIELD APP": "{n} من مواقع الفرق مباشرة من التطبيق الميداني",
  "{n} STALE AND NOT DRAWN": "{n} قديمة ولم تُرسم",
  "{n} DEVICE(S) NAMING A TEAM NOT IN THE REGISTER": "{n} من الأجهزة تسمّي فريقًا غير موجود في السجل",
  "{n} POSITION(S) RECEIVED, NONE USABLE — {stale} STALE": "استُلم {n} من المواقع، ولا يصلح أي منها — {stale} قديمة",
  "NO PHONE IS REPORTING · TEAM POSITIONS BELOW ARE SIMULATED": "لا يُبلغ أي هاتف · مواقع الفرق أدناه محاكاة",
  "Loading the aerodrome plan…": "جارٍ تحميل مخطط المطار…",
  DETAIL: "التفاصيل",
  "WORK ORDERS": "أوامر العمل",
  "ACTIVE SITES": "المواقع النشطة",
  TEAMS: "الفرق",
  "click an item or any point on the map": "انقر عنصرًا أو أي نقطة على الخريطة",
  "EMERGENCY · ALL RFF": "طوارئ · جميع فرق الإنقاذ ومكافحة الحريق (RFF)",
  SEND: "إرسال",
  "INSPECT {r}": "فحص {r}",
  RECALL: "استدعاء",
  "DISPATCHED AS {who} · TEAM POSITIONS ARE SIMULATED UNTIL A VEHICLE FEED IS CONNECTED · REAL VIEWS ARE PAINTED FROM THE RECORDS; DERIVED ITEMS ARE MARKED":
    "الإرسال باسم {who} · مواقع الفرق محاكاة حتى تُربط تغذية المركبات · العروض الواقعية مرسومة من السجلات؛ والعناصر المستنتجة مُعلَّمة",
  "Click a work order, an asset or any point on the map.": "انقر أمر عمل أو أصلًا أو أي نقطة على الخريطة.",
  "what they are being sent for (optional)": "سبب إرسالهم (اختياري)",
  "Dispatch note": "ملاحظة الإرسال",
  "EMERGENCY · ALL RFF TO TARGET": "طوارئ · جميع فرق RFF إلى الوجهة",
  "Dispatched as {who}. Positions are simulated until a vehicle feed is connected; routes follow the inferred service roads and hold short of a runway until cleared.":
    "الإرسال باسم {who}. المواقع محاكاة حتى تُربط تغذية المركبات؛ وتتبع المسارات طرق الخدمة المستنتجة وتتوقف قبل المدرج حتى يؤذن بالعبور.",
  "{m} m by road": "{m} m عبر الطريق",
  "{n} crossing(s)": "{n} عبور",

  /* ── the map readout ────────────────────────────────────────────────── */
  EMERGENCY: "طوارئ",
  "{status} · opened {date}": "{status} · فُتح في {date}",
  "Responding: {teams}": "يستجيب: {teams}",
  "on scene": "في الموقع",
  "Assigned: {crew}": "مُسنَد إلى: {crew}",
  "No team responding": "لا يستجيب أي فريق",
  "Company: {company}": "الشركة: {company}",
  "Company: not assigned": "الشركة: غير محددة",
  "Job: {id} · {urgency} · {type}": "المهمة: {id} · {urgency} · {type}",
  "{n} runway crossing(s)": "{n} عبور للمدرج",
  "{teams} responding": "يستجيب {teams}",
  "nothing open": "لا شيء مفتوح",
  "{n} open work order|{n} open work orders":
    "لا أوامر عمل مفتوحة|أمر عمل مفتوح واحد|أمرا عمل مفتوحان|{n} أوامر عمل مفتوحة|{n} أمر عمل مفتوحًا|{n} أمر عمل مفتوح",
  asset: "أصل",
  "Holding positions": "مواقع الانتظار",
  Thresholds: "عتبات المدرج",
  Helipads: "مهابط المروحيات",
  Navaids: "المساعدات الملاحية",
  "AGL lights": "أضواء الإنارة الأرضية (AGL)",
  "Vertical signs": "اللوحات الإرشادية الرأسية",
  "Buildings & infrastructure": "المباني والبنية التحتية",
  Runways: "المدارج",
  Taxiways: "ممرات الطائرات",
  Aprons: "ساحات وقوف الطائرات",
  "Service roads": "طرق الخدمة",
  AVAILABLE: "متاح",
  RESPONDING: "يستجيب",
  ONSCENE: "في الموقع",
  RETURNING: "عائد",
  OFFDUTY: "خارج الخدمة",
  acknowledged: "تم الإقرار",
  "in progress": "قيد التنفيذ",
  awaiting: "بانتظار",
  completed: "مكتمل",

  /* ── canvas figures ─────────────────────────────────────────────────── */
  "RWY 17/35 · CAT III · AGL SERVICEABLE": "RWY 17/35 · CAT III · AGL صالحة للخدمة",
  "PREDICTIVE MODEL · SCANNING": "النموذج التنبؤي · يمسح",
  "no history yet": "لا سجل بعد",
  "AWAITING COUNTERS": "بانتظار العدادات",
  "PROJ · {s}s": "متوقع · {s}s",
  "12 WEEKS": "12 أسبوعًا",
  "PEAK {n}": "الذروة {n}",
  "{n} INDICATORS": "{n} مؤشر",
  "{nogo} OUTSIDE LIMITS · {caution} ON WATCH": "{nogo} خارج الحدود · {caution} تحت المراقبة",
  "Safety critical": "حرج للسلامة",
  Operational: "تشغيلي",
  "Passenger service": "خدمة الركاب",
  Resilience: "المرونة",
  "CLOSED PER": "المُغلق لكل",
  "RAISED, 90d": "مُفتوح، 90 يومًا",
  "■ RAISED": "■ المُفتوح",
  "■ CLOSED": "■ المُغلق",
  "no closure time yet": "لا زمن إغلاق بعد",
  "MEDIAN {n}d": "الوسيط {n} يوم",
  "{n} STILL OPEN": "{n} ما زالت مفتوحة",
  Movements: "الحركات",
  Queues: "الطوابير",
  "Fire cover": "تغطية الإطفاء",
  Alarms: "الإنذارات",
  Emergency: "الطوارئ",
  "DECLARED CAPACITY NOT SET": "السعة المعلنة غير محددة",
  "aerodrome manual and slot file": "دليل المطار وملف الفترات الزمنية",
  "DECLARED {n}/HR": "المعلن {n}/ساعة",
  "TIGHTEST CONSTRAINT": "القيد الأشد",
  HEADROOM: "الهامش المتاح",
  "NOT FED": "لا تغذية",
  "PASSENGER FEED NOT CONNECTED": "تغذية الركاب غير مربوطة",
  YTD: "منذ بداية العام",
  "LAST YR": "العام الماضي",
  FORECAST: "التوقع",
  "ON LAST YEAR": "مقارنة بالعام الماضي",
  "CUMULATIVE PACE": "الوتيرة التراكمية",
  "LAST YEAR NOT SUPPLIED — NOTHING TO COMPARE": "بيانات العام الماضي غير متوفرة — لا شيء للمقارنة",
  "MONTH ON SAME MONTH LAST YEAR": "الشهر مقارنة بالشهر نفسه من العام الماضي",
  "READINESS INDEX": "مؤشر الجاهزية",

  /* ── the instruments desk ───────────────────────────────────────────── */
  GO: "صالح",
  CAUTION: "تحذير",
  "NO-GO": "غير صالح",
  "NO DATA": "لا بيانات",
  "Reading entered": "أُدخلت قراءة",
  Note: "ملاحظة",
  "Action recorded": "سُجّل إجراء",
  Acknowledged: "تم الإقرار",
  "Flight entered": "أُدخلت رحلة",
  "{to} entered by {by} {time}": "{to} أدخلها {by} {time}",
  "Entered by hand today by {by} at {time}, over the derived reading ({from}).":
    "أدخلها يدويًا اليوم {by} الساعة {time}، فوق القراءة المستنتجة ({from}).",
  "{kind} — {by}, {time}, kept on the platform.": "{kind} — {by}، {time}، محفوظ على المنصة.",
  "{kind} — {by}, {time}, kept on the browser.": "{kind} — {by}، {time}، محفوظ في المتصفح.",
  INSTRUMENTS: "العدادات",
  "the aerodrome's instruments, read from the records — open any dial for its data and source, enter a reading by hand, and the day keeps who changed what":
    "عدادات المطار، مقروءة من السجلات — افتح أي عداد لبياناته ومصدره، وأدخل قراءة يدويًا، ويحفظ اليوم من غيّر ماذا",
  readings: "قراءة",
  "urgent issue(s)": "مسألة عاجلة",
  "night window(s) tonight": "نافذة ليلية الليلة",
  "signed in as": "مسجّل الدخول باسم",
  "every reading derived from a record; click a reading for its data and source":
    "كل قراءة مستنتجة من سجل؛ انقر القراءة لبياناتها ومصدرها",
  "Bar meters": "العدادات الشريطية",
  "Bar meters · big": "العدادات الشريطية · مكبّرة",
  "Vertical bars": "الأشرطة الرأسية",
  "Progress · surface": "التقدم · السطح",
  "Gauge grid": "شبكة المقاييس",
  "Tri gauge": "المقياس الثلاثي",
  "Electrical & lighting": "الكهرباء والإنارة",
  "Donut · stands": "حلقة · مواقف الطائرات",
  "Bars · work raised": "أشرطة · الأعمال المفتوحة",
  "Trend · rubber outlook": "اتجاه · توقعات المطاط",
  "Spark · twelve weeks": "خط مصغّر · اثنا عشر أسبوعًا",
  "The safety-critical tier: friction, rubber, markings and lighting, segmented, with scale ticks at 0/50/100.":
    "المستوى الحرج للسلامة: الاحتكاك والمطاط والعلامات الأرضية والإنارة، مجزأة، مع علامات مقياس عند 0/50/100.",
  "The same instrument magnified, as it appears when a tile is opened.":
    "العداد نفسه مكبّرًا، كما يظهر عند فتح البطاقة.",
  "Tier one. Threshold marks sit at the caution and go boundaries.":
    "المستوى الأول. علامات الحدود عند حدّي التحذير والصلاحية.",
  "The surface conditions as a proportion of clear: FOD, wildlife, spills and sweeping.":
    "حالات السطح كنسبة من الخلو: الأجسام الغريبة (FOD) والحياة الفطرية والانسكابات والكنس.",
  "Six dials: friction, rubber, markings, lighting, signs and navaids.":
    "ستة عدادات: الاحتكاك والمطاط والعلامات الأرضية والإنارة واللوحات الإرشادية والمساعدات الملاحية.",
  "Three dials across: friction, rubber and markings.": "ثلاثة عدادات متجاورة: الاحتكاك والمطاط والعلامات الأرضية.",
  "{total} stands: {free} free, {occ} occupied, {oos} out of service, from the stand feed.":
    "{total} موقف طائرة: {free} شاغر، {occ} مشغول، {oos} خارج الخدمة، من تغذية المواقف.",
  "{total} stands in the survey; occupancy awaits the stand allocation feed, so the ring shows the inventory only.":
    "{total} موقف طائرة في المسح؛ الإشغال بانتظار تغذية تخصيص المواقف، لذا تعرض الحلقة المخزون فقط.",
  "Work orders raised in each of the last six weeks, from the work order log.":
    "أوامر العمل المفتوحة في كل أسبوع من الأسابيع الستة الأخيرة، من سجل أوامر العمل.",
  "Twelve weeks ahead: how much of the removal level remains on the worst end at the model's rate, against the same thresholds the meters use.":
    "اثنا عشر أسبوعًا قادمة: كم يتبقى حتى مستوى الإزالة على أسوأ طرف بمعدل النموذج، مقابل الحدود نفسها التي تستخدمها العدادات.",
  "The rubber outlook needs a treatment on record to count from; the model has none.":
    "تحتاج توقعات المطاط إلى معالجة مسجلة للعد منها؛ ولا توجد لدى النموذج أي معالجة.",
  "Three bare traces: work orders raised (red), findings raised (green) and FOD reports (amber), by week.":
    "ثلاثة خطوط مجردة: أوامر العمل المفتوحة (أحمر) والملاحظات المسجلة (أخضر) وبلاغات FOD (كهرماني)، أسبوعيًا.",
  "Today's flight schedule": "جدول رحلات اليوم",
  "{n} movements": "{n} حركة",
  "traffic feed": "تغذية الحركة الجوية",
  SAMPLE: "تجريبي",
  "Movements by hour": "الحركات حسب الساعة",
  "Quiet windows · 45 min or more with no movement": "النوافذ الهادئة · 45 min أو أكثر دون حركة",
  night: "ليلية",
  "none today": "لا شيء اليوم",
  Flight: "الرحلة",
  Airline: "شركة الطيران",
  City: "المدينة",
  Stand: "موقف الطائرة",
  "entered by hand": "أُدخلت يدويًا",
  landed: "هبطت",
  departed: "أقلعت",
  delayed: "متأخرة",
  "canceled": "ملغاة",
  "Urgent issues & mitigation": "المسائل العاجلة والتخفيف",
  "every reading below limit, every open P1 and every open incident this week, with the action for each":
    "كل قراءة دون الحد، وكل P1 مفتوح، وكل حادثة مفتوحة هذا الأسبوع، مع الإجراء لكل منها",
  "Nothing on the desk needs urgent action.": "لا شيء في المكتب يحتاج إلى إجراء عاجل.",
  "Mitigation · {owner}:": "التخفيف · {owner}:",
  "{kind} by {by} at {time}": "{kind} بواسطة {by} الساعة {time}",
  "Open the reading": "افتح القراءة",
  Predictions: "التنبؤات",
  "rates from the records, with the basis and how much history stands behind each":
    "معدلات من السجلات، مع الأساس وحجم السجل التاريخي وراء كل منها",
  Instrument: "العداد",
  Horizon: "المدى",
  Prediction: "التنبؤ",
  Level: "المستوى",
  Confidence: "الثقة",
  Basis: "الأساس",
  good: "جيدة",
  fair: "مقبولة",
  thin: "ضعيفة",
  "Optimizer": "المُحسِّن",
  "the open airfield work packed into today's quiet windows — P1 first, then what is due soonest, one closure carrying several jobs":
    "أعمال الجانب الجوي المفتوحة موزعة على نوافذ اليوم الهادئة — P1 أولًا، ثم الأقرب استحقاقًا، وإغلاق واحد يحمل عدة مهام",
  "Closures planned · {n} for {m} job(s)": "الإغلاقات المخططة · {n} لـ {m} مهمة",
  "{h} h used": "{h} h مستخدمة",
  "due in {n} d": "يستحق خلال {n} يوم",
  "No open airfield work to place.": "لا أعمال مفتوحة في الجانب الجوي لجدولتها.",
  "Does not fit today": "لا يتسع له اليوم",
  "Sweeps · the widest daytime gaps": "الكنس · أوسع الفجوات النهارية",
  "no daytime gap of thirty minutes": "لا فجوة نهارية من ثلاثين دقيقة",
  "Sweeps go where the schedule is quietest by day; closures go where it is quietest by night. Both are read from the same schedule, so a flight entered above moves them.":
    "يوضع الكنس حيث يكون الجدول أهدأ نهارًا، والإغلاقات حيث يكون أهدأ ليلًا. كلاهما مقروء من الجدول نفسه، لذا تحرّكهما أي رحلة تُدخل أعلاه.",
  "every change on this desk, by day — who, what kind, and what it changed":
    "كل تغيير في هذا المكتب، حسب اليوم — من، وأي نوع، وماذا غيّر",
  "Nothing entered yet. A reading, a note, an action or a flight entered here is kept with your name and the time.":
    "لم يُدخل شيء بعد. أي قراءة أو ملاحظة أو إجراء أو رحلة تُدخل هنا تُحفظ باسمك والوقت.",
  today: "اليوم",
  "{n} change(s)": "{n} تغيير",
  "{label} — data and source": "{label} — البيانات والمصدر",
  "Records behind it · {n}": "السجلات وراءها · {n}",
  job: "مهمة",
  finding: "ملاحظة",
  incident: "حادثة",
  survey: "مسح",
  feed: "تغذية",
  model: "نموذج",
  entry: "إدخال",
  "none — there is nothing on the platform to read from": "لا شيء — لا يوجد على المنصة ما يُقرأ منه",
  "What it predicts": "ما يتنبأ به",
  "Enter by hand · as {who}": "إدخال يدوي · باسم {who}",
  "Reading 0–100": "القراءة 0–100",
  Reading: "القراءة",
  "what was seen, measured or decided": "ما شوهد أو قيس أو تقرر",
  "Enter reading": "إدخال القراءة",
  "Add note only": "إضافة ملاحظة فقط",
  "A reading entered today overrides the derived dial until midnight and is kept in the history with your name; the derived reading is never lost.":
    "القراءة المدخلة اليوم تحل محل العداد المستنتج حتى منتصف الليل وتُحفظ في السجل باسمك؛ ولا تضيع القراءة المستنتجة أبدًا.",
  "History of this reading · {n}": "سجل هذه القراءة · {n}",
  "nothing entered against it yet": "لم يُدخل عليها شيء بعد",
  "what was done": "ما الذي نُفّذ",
  "Action on {title}": "إجراء على {title}",
  "Record action taken": "تسجيل الإجراء المتخذ",
  Acknowledge: "إقرار",
  "Enter a flight · as {who}": "إدخال رحلة · باسم {who}",
  "Flight time": "وقت الرحلة",
  "Flight number": "رقم الرحلة",
  "Arr/Dep": "وصول/مغادرة",
  "Arrival or departure": "وصول أو مغادرة",
  Arrival: "وصول",
  Departure: "مغادرة",
  "Add to today": "إضافة إلى اليوم",

  /* mitigations and who holds them */
  "Restrict the affected taxiway segment at night or place a follow-me; NOTAM the outage; AGL crew to replace the units in the next quiet window and confirm the circuit.":
    "قيّد جزء ممر الطائرات المتأثر ليلًا أو ضع مركبة إرشاد؛ أصدر NOTAM بالعطل؛ ويستبدل فريق AGL الوحدات في النافذة الهادئة التالية ويتحقق من الدائرة.",
  "Downgrade the runway's category status if a circuit is affected; NOTAM; AGL crew to the units in the next window.":
    "خفّض فئة المدرج إن تأثرت دائرة؛ أصدر NOTAM؛ ويتوجه فريق AGL إلى الوحدات في النافذة التالية.",
  "AGL crew to the open lighting jobs in the next window; check the constant-current regulators for the circuit.":
    "يتوجه فريق AGL إلى مهام الإنارة المفتوحة في النافذة التالية؛ وافحص منظّمات التيار الثابت للدائرة.",
  "ATC advised of the aid's status; fall back to the non-precision procedure; flight check after the repair.":
    "إبلاغ المراقبة الجوية بحالة المساعدة الملاحية؛ الرجوع إلى إجراء الاقتراب غير الدقيق؛ ومعايرة جوية بعد الإصلاح.",
  "Survey the floodlight masts into the inventory so the reading can be taken.":
    "مسح صواري الإنارة الكاشفة وإضافتها إلى المخزون حتى يمكن أخذ القراءة.",
  "Book the removal in the next quiet window of four hours on that runway; friction survey after the run.":
    "احجز الإزالة في النافذة الهادئة التالية ذات الأربع ساعات على ذلك المدرج؛ ومسح احتكاك بعد التنفيذ.",
  "NOTAM reduced braking action if below the planning level; restrict operations in wet; treat the touchdown zone.":
    "أصدر NOTAM بانخفاض فاعلية الكبح إن كانت دون مستوى التخطيط؛ قيّد العمليات في حالة البلل؛ وعالج منطقة ملامسة الأرض.",
  "Repaint in the next window; cones or temporary markers where guidance is misleading meanwhile.":
    "أعد الطلاء في النافذة التالية؛ وضع أقماعًا أو علامات مؤقتة حيث يكون التوجيه مضللًا في الأثناء.",
  "Replace or clean the panel; ATC advised where a mandatory sign is illegible at night.":
    "استبدل اللوحة أو نظّفها؛ وأبلغ المراقبة الجوية حيث تكون لوحة إلزامية غير مقروءة ليلًا.",
  "Dispatch the sweeper; runway check before the next movement; trace the source of the debris.":
    "أرسل الكانسة؛ وافحص المدرج قبل الحركة التالية؛ وتتبّع مصدر الحطام.",
  "Dispersal patrol to the movement area; NOTAM bird activity; check attractants — standing water, grass height, waste.":
    "دورية تنفير إلى منطقة الحركة؛ أصدر NOTAM بنشاط الطيور؛ وافحص عوامل الجذب — المياه الراكدة وطول العشب والنفايات.",
  "Contain and absorb; close the stand until clean; friction check on the surface afterwards; environment office informed.":
    "احتوِ وامتص؛ أغلق موقف الطائرة حتى يُنظَّف؛ وافحص احتكاك السطح بعد ذلك؛ وأبلغ مكتب البيئة.",
  "Bring the next sweep forward into the widest gap in the schedule and log it.":
    "قدّم الكنس التالي إلى أوسع فجوة في الجدول وسجّله.",
  "Confirm the standby generators and UPS; shed non-critical load; AGL supply is the priority.":
    "تحقق من المولدات الاحتياطية ومزوّد الطاقة غير المنقطعة (UPS)؛ خفّف الأحمال غير الحرجة؛ والأولوية لتغذية AGL.",
  "Open the reading and decide.": "افتح القراءة وقرّر.",
  "Crew to the job today; the desk shows no reading carrying it, so open it and confirm the asset.":
    "يتوجه الفريق إلى المهمة اليوم؛ لا يُظهر المكتب قراءة تحملها، فافتحها وتحقق من الأصل.",
  "Investigate and close under the SMS; record the immediate control taken.":
    "حقّق وأغلق ضمن نظام إدارة السلامة (SMS)؛ وسجّل الإجراء الفوري المتخذ.",
  "AGL crew": "فريق AGL",
  "Navaids engineer": "مهندس المساعدات الملاحية",
  Survey: "المسح",
  Pavements: "الرصف",
  "Airside ops": "عمليات الجانب الجوي",
  Electrical: "الكهرباء",
  "Duty manager": "المدير المناوب",
  "Safety office": "مكتب السلامة",

  /* the desk's schedule, optimiser and predictions */
  "Hourly volume from the traffic feed; flight detail is the built-in sample until the AODB is connected.":
    "الحجم بالساعة من تغذية الحركة الجوية؛ وتفاصيل الرحلات من العينة المدمجة حتى تُربط قاعدة بيانات عمليات المطار (AODB).",
  "No AODB connected: this is the built-in sample day for OEMA, the same for this date every time it is opened, with what has been entered by hand laid over it.":
    "لا توجد AODB مربوطة: هذا يوم العينة المدمج لـ OEMA، وهو نفسه لهذا التاريخ في كل مرة يُفتح، مع ما أُدخل يدويًا فوقه.",
  "Rubber removal due — {label}": "إزالة المطاط مستحقة — {label}",
  "the {window} gap, {n} min with no movement": "فجوة {window}، {n} min دون حركة",
  "{n} job(s) in {c} closure(s) instead of {n}.": "{n} مهمة في {c} إغلاق بدلًا من {n}.",
  "{n} job(s) do not fit today's windows — the longest gap is {gap} min.":
    "{n} مهمة لا تتسع لها نوافذ اليوم — أطول فجوة {gap} min.",
  "Only {n} of {target} sweeps fit in gaps of thirty minutes or more.":
    "يتسع {n} فقط من {target} عمليات كنس في فجوات من ثلاثين دقيقة أو أكثر.",
  "RWY {desig} rubber": "مطاط RWY {desig}",
  "to removal level": "حتى مستوى الإزالة",
  "no rate": "لا معدل",
  "{n} days from a clean": "{n} يوم من التنظيف",
  "{kg} kg a day from {tyres} tires landing on this end; no treatment on record to count from.":
    "{kg} kg يوميًا من {tyres} إطار تهبط على هذا الطرف؛ ولا معالجة مسجلة للعد منها.",
  "{kg} kg a day from {tyres} tires landing on this end; {pct}% of the removal level already down.":
    "{kg} kg يوميًا من {tyres} إطار تهبط على هذا الطرف؛ وقد تراكم {pct}% من مستوى الإزالة.",
  "{runway} friction": "احتكاك {runway}",
  "to planning level": "حتى مستوى التخطيط",
  "not declining": "لا ينخفض",
  "Mean {mean} on {date} against {prev} on {prevDate}: {rate} a month, from two surveys.":
    "المتوسط {mean} في {date} مقابل {prev} في {prevDate}: {rate} شهريًا، من مسحين.",
  "AGL lamp failures": "أعطال مصابيح AGL",
  "next {n} days": "الأيام الـ {n} القادمة",
  "{n} expected ({lo}–{hi})": "{n} متوقع ({lo}–{hi})",
  "{n} units on an eight-year lamp life at eleven burning hours a night; a Poisson band, not a measurement.":
    "{n} وحدة بعمر مصباح ثماني سنوات وإحدى عشرة ساعة تشغيل ليلًا؛ نطاق بواسون، وليس قياسًا.",
  "none, on no reports": "لا شيء، لعدم وجود بلاغات",
  "{n} report(s) in the incident log over {days} days — too few to separate a trend from chance.":
    "{n} بلاغ في سجل الحوادث خلال {days} يوم — أقل من أن يُميَّز الاتجاه عن المصادفة.",
  "{n} report(s) in the incident log over {days} days.": "{n} بلاغ في سجل الحوادث خلال {days} يوم.",
  "FOD reports": "بلاغات FOD",
  "Wildlife strikes": "اصطدامات الحياة الفطرية",
  Spills: "الانسكابات",
  "Sign faults": "أعطال اللوحات الإرشادية",
  "{n} expected": "{n} متوقع",
  "none, on no jobs": "لا شيء، لعدم وجود مهام",
  "{n} sign job(s) raised in twelve months.": "{n} مهمة للوحات الإرشادية خلال اثني عشر شهرًا.",
  "Sweeps by end of day": "عمليات الكنس بنهاية اليوم",
  "{n} of {target} at this pace": "{n} من {target} بهذه الوتيرة",
  "{n} completed so far, against {target}.": "اكتمل {n} حتى الآن، مقابل {target}.",

  /* the readings */
  "{jobs}, {findings} open": "{jobs}، {findings} مفتوحة",
  "no fault on record": "لا عطل مسجل",
  "{incidents}, {items} open": "{incidents}، {items} مفتوحة",
  "{n} job|{n} jobs": "لا مهام|مهمة واحدة|مهمتان|{n} مهام|{n} مهمة|{n} مهمة",
  "{n} finding|{n} findings": "لا ملاحظات|ملاحظة واحدة|ملاحظتان|{n} ملاحظات|{n} ملاحظة|{n} ملاحظة",
  "{n} incident|{n} incidents": "لا حوادث|حادثة واحدة|حادثتان|{n} حوادث|{n} حادثة|{n} حادثة",
  "{n} item|{n} items": "لا عناصر|عنصر واحد|عنصران|{n} عناصر|{n} عنصرًا|{n} عنصر",
  "{n} sign|{n} signs": "لا لوحات|لوحة واحدة|لوحتان|{n} لوحات|{n} لوحة|{n} لوحة",
  "{n} strike|{n} strikes": "لا اصطدامات|اصطدام واحد|اصطدامان|{n} اصطدامات|{n} اصطدامًا|{n} اصطدام",
  "{n} spill|{n} spills": "لا انسكابات|انسكاب واحد|انسكابان|{n} انسكابات|{n} انسكابًا|{n} انسكاب",
  "{n} {what} in the survey inventory": "{n} من {what} في مخزون المسح",
  "navaids and PAPI": "المساعدات الملاحية وPAPI",
  "runway lighting units": "وحدات إنارة المدرج",
  "taxiway lighting units": "وحدات إنارة ممرات الطائرات",
  "holding positions": "مواقع الانتظار",
  "floodlight masts": "صواري الإنارة الكاشفة",
  signs: "اللوحات الإرشادية",
  "AGL units": "وحدات AGL",
  "{n} units": "{n} وحدة",
  "{n} holding positions": "{n} موقع انتظار",
  "{n} aids incl. {papi} PAPI · {faults}": "{n} مساعدة ملاحية منها {papi} PAPI · {faults}",
  "The survey inventory of navaids and PAPI, and every open job or finding on an aid.":
    "مخزون المسح للمساعدات الملاحية وPAPI، وكل مهمة أو ملاحظة مفتوحة على مساعدة.",
  "Runway lighting": "إنارة المدرج",
  "The runway centerline, edge and threshold units in the survey inventory, and every open lighting job on them.":
    "وحدات خط منتصف المدرج وحافته وعتبته في مخزون المسح، وكل مهمة إنارة مفتوحة عليها.",
  "Taxiway lighting": "إنارة ممرات الطائرات",
  "The taxiway units in the survey inventory and every open taxiway lighting job.":
    "وحدات ممرات الطائرات في مخزون المسح وكل مهمة إنارة مفتوحة لممرات الطائرات.",
  "The survey has not captured the taxiway circuits, so the holding positions stand in, with every open taxiway or holding-position lighting job.":
    "لم يلتقط المسح دوائر ممرات الطائرات، لذا تحل مواقع الانتظار محلها، مع كل مهمة إنارة مفتوحة لممرات الطائرات أو مواقع الانتظار.",
  "Apron floodlights": "الإنارة الكاشفة لساحة وقوف الطائرات",
  "{n} masts": "{n} صاري",
  "The floodlight masts in the survey inventory and every open floodlighting job.":
    "صواري الإنارة الكاشفة في مخزون المسح وكل مهمة إنارة كاشفة مفتوحة.",
  "not in the survey inventory": "غير موجودة في مخزون المسح",
  "The apron floodlight masts are not in the survey inventory yet, and no job or finding names one — there is nothing to read.":
    "صواري الإنارة الكاشفة لساحة وقوف الطائرات ليست في مخزون المسح بعد، ولا تسمّي أي مهمة أو ملاحظة أحدها — لا يوجد ما يُقرأ.",
  Voltage: "الجهد",
  Consumption: "الاستهلاك",
  "Grid health": "سلامة الشبكة",
  Substations: "المحطات الفرعية",
  "Every substation's open jobs, findings and last inspection, as the dashboard's electrical tile reads them.":
    "المهام والملاحظات المفتوحة وآخر فحص لكل محطة فرعية، كما تقرؤها بطاقة الكهرباء في لوحة المعلومات.",
  "The power feed — delivered voltage, load, frequency, power factor and distortion — as the dashboard's electrical tile reads it.":
    "تغذية الطاقة — الجهد المورَّد والحمل والتردد ومعامل القدرة والتشوه — كما تقرؤها بطاقة الكهرباء في لوحة المعلومات.",
  "Power feed · {state}": "تغذية الطاقة · {state}",
  "Runway friction": "احتكاك المدرج",
  "The latest continuous friction survey on each runway end, and whether a post-removal verification is due.":
    "أحدث مسح احتكاك مستمر على كل طرف من المدرج، وهل يستحق تحقق ما بعد الإزالة.",
  "no survey": "لا مسح",
  "No friction survey on file.": "لا يوجد مسح احتكاك في الملف.",
  "Rubber loading": "تراكم المطاط",
  "The rubber model — landings, tire mix and grams per tire on each touchdown zone — against the removal level, from the last treatment on record.":
    "نموذج المطاط — الهبوطات ومزيج الإطارات والغرامات لكل إطار على كل منطقة ملامسة الأرض — مقابل مستوى الإزالة، منذ آخر معالجة مسجلة.",
  "RWY {desig} · {kg} kg/day · {days} days clean to removal level":
    "RWY {desig} · {kg} kg/يوم · {days} يوم من التنظيف حتى مستوى الإزالة",
  "no model": "لا نموذج",
  "No rubber model.": "لا يوجد نموذج للمطاط.",
  Markings: "العلامات الأرضية",
  "Every open marking job and finding — repaints, centerlines, edge lines and designators.":
    "كل مهمة وملاحظة مفتوحة للعلامات الأرضية — إعادة الطلاء وخطوط المنتصف وخطوط الحافة والمعرّفات.",
  Signs: "اللوحات الإرشادية",
  "The mandatory and information signs in the survey inventory, and every open sign job or finding.":
    "اللوحات الإلزامية والإرشادية في مخزون المسح، وكل مهمة أو ملاحظة مفتوحة على اللوحات.",
  Lighting: "الإنارة",
  "{n} AGL units": "{n} وحدة AGL",
  "Every AGL unit in the survey inventory and every open lighting job or finding, runway, taxiway or apron.":
    "كل وحدة AGL في مخزون المسح وكل مهمة أو ملاحظة إنارة مفتوحة، في المدرج أو ممر الطائرات أو ساحة وقوف الطائرات.",
  "FOD feed · {state} — sweeper log and runway checks": "تغذية FOD · {state} — سجل الكنس وفحوص المدرج",
  "FOD condition": "حالة الأجسام الغريبة (FOD)",
  "FOD reports in the incident log over thirty days, open FOD jobs, and surface defects shedding material.":
    "بلاغات FOD في سجل الحوادث خلال ثلاثين يومًا، ومهام FOD المفتوحة، وعيوب السطح التي تتساقط منها مواد.",
  "no FOD reading": "لا قراءة FOD",
  "No FOD reading.": "لا توجد قراءة FOD.",
  "Environment feed · {state}": "تغذية البيئة · {state}",
  "Wildlife status": "حالة الحياة الفطرية",
  "{strikes} in 12 months · target {target}": "{strikes} خلال 12 شهرًا · المستهدف {target}",
  "Wildlife strikes over twelve months from the environment feed, against its target.":
    "اصطدامات الحياة الفطرية خلال اثني عشر شهرًا من تغذية البيئة، مقابل مستهدفها.",
  "no report on record": "لا بلاغ مسجل",
  "The environment feed is not connected, so this reads the incident log and what is open in jobs and findings for birds and wildlife.":
    "تغذية البيئة غير مربوطة، لذا يُقرأ سجل الحوادث وما هو مفتوح من المهام والملاحظات المتعلقة بالطيور والحياة الفطرية.",
  "Spill contamination": "تلوث الانسكابات",
  "{spills} in 30 days": "{spills} خلال 30 يومًا",
  "Spills over thirty days from the environment feed.": "الانسكابات خلال ثلاثين يومًا من تغذية البيئة.",
  "The environment feed is not connected, so this reads the incident log and what is open in jobs and findings for fuel, oil and hydraulic spills.":
    "تغذية البيئة غير مربوطة، لذا يُقرأ سجل الحوادث وما هو مفتوح من المهام والملاحظات المتعلقة بانسكابات الوقود والزيت والسوائل الهيدروليكية.",
  "Cleaning & sweeping": "التنظيف والكنس",
  "Sweeps completed today against the target, from the sweeper log in the FOD feed.":
    "عمليات الكنس المكتملة اليوم مقابل المستهدف، من سجل الكنس في تغذية FOD.",
  "awaiting feed": "بانتظار التغذية",
  "The sweeper log has not arrived.": "لم يصل سجل الكنس.",
  "Civil surface": "السطح المدني",
  "Friction from the latest survey on each end; rubber from the model of landings and tires on each touchdown zone against the removal level; markings and signs from what is open against them; lighting from every AGL unit and every open lighting job.":
    "الاحتكاك من أحدث مسح على كل طرف؛ والمطاط من نموذج الهبوطات والإطارات على كل منطقة ملامسة الأرض مقابل مستوى الإزالة؛ والعلامات الأرضية واللوحات الإرشادية مما هو مفتوح عليها؛ والإنارة من كل وحدة AGL وكل مهمة إنارة مفتوحة.",
  "Airfield lighting": "إنارة الجانب الجوي",
  "Read from the survey inventory and what is open against it: navaids and PAPI, the runway centreline, edge and threshold circuits, {taxiway}, and the apron floodlights. A P1 job weighs most; an open finding next.":
    "مقروءة من مخزون المسح وما هو مفتوح عليه: المساعدات الملاحية وPAPI، ودوائر خط منتصف المدرج وحافته وعتبته، و{taxiway}، والإنارة الكاشفة لساحة وقوف الطائرات. لمهمة P1 الوزن الأكبر، ثم للملاحظة المفتوحة.",
  "Read from the survey inventory and what is open against it: navaids and PAPI, the runway centreline, edge and threshold circuits, {taxiway}, and the apron floodlights, which are not in the inventory yet and so read as no data. A P1 job weighs most; an open finding next.":
    "مقروءة من مخزون المسح وما هو مفتوح عليه: المساعدات الملاحية وPAPI، ودوائر خط منتصف المدرج وحافته وعتبته، و{taxiway}، والإنارة الكاشفة لساحة وقوف الطائرات، وهي ليست في المخزون بعد فتُقرأ بلا بيانات. لمهمة P1 الوزن الأكبر، ثم للملاحظة المفتوحة.",
  "the taxiway circuits": "دوائر ممرات الطائرات",
  "the holding positions in place of taxiway circuits the survey has not captured":
    "مواقع الانتظار بدلًا من دوائر ممرات الطائرات التي لم يلتقطها المسح",
  "Power supply": "تغذية الطاقة",
  "The supply behind the lighting, as the dashboard's electrical tile reads it: delivered voltage against nominal, load against declared capacity, frequency, power factor and distortion, and the state of every substation from its open jobs, findings and last inspection.":
    "التغذية التي تقف خلف الإنارة، كما تقرؤها بطاقة الكهرباء في لوحة المعلومات: الجهد المورَّد مقابل الاسمي، والحمل مقابل السعة المعلنة، والتردد ومعامل القدرة والتشوه، وحالة كل محطة فرعية من مهامها وملاحظاتها المفتوحة وآخر فحص.",
  "Surface condition": "حالة السطح",
  "FOD condition is the finds and the shedding surface defects from the platform's FOD reading; sweeping is the sweeper log against today's target. Wildlife and spills read from the environment feed when it is connected, and until then from the incident log and what is open in jobs and findings — no report on record reads clear, and says so.":
    "حالة FOD هي المضبوطات وعيوب السطح المتساقطة من قراءة FOD في المنصة؛ والكنس هو سجل الكنس مقابل مستهدف اليوم. تُقرأ الحياة الفطرية والانسكابات من تغذية البيئة عند ربطها، وإلى ذلك الحين من سجل الحوادث وما هو مفتوح من المهام والملاحظات — وغياب البلاغ المسجل يُقرأ خاليًا، ويُذكر ذلك.",
  /* ── Instruments: the bar meters, re-pointed at airside systems and facility condition ── */
  "no inspection on record": "لا فحص مسجل",
  "Facility inspections by this trade — none recorded yet.": "فحوصات المرافق لهذا التخصص — لم يُسجل شيء بعد.",
  "{n} facilities": "{n} مرافق",
  "Each facility's latest detailed inspection by this trade, averaged over the facilities it has inspected — from Facility inspections in Asset Management.":
    "آخر فحص تفصيلي لكل مرفق من هذا التخصص، بمتوسط على المرافق التي فحصها — من فحص المرافق في إدارة الأصول.",
  "These are sample records.": "هذه سجلات نموذجية.",
  "Facility condition": "حالة المرافق",
  "Each trade's condition of the facilities it inspects, from Facility inspections.": "حالة المرافق لدى كل تخصص يفحصها، من فحص المرافق.",
  "The meteorological stations, stands, runway holding positions and helipads, each read from the survey inventory and every job and finding open against it.":
    "محطات الأرصاد والمواقف ونقاط الانتظار على المدرج ومهابط المروحيات، كلٌّ مقروء من سجل المسح وكل عمل وملاحظة مفتوحة عليه.",
  "Each trade's condition of the airport's facilities, from its latest detailed inspections in Facility inspections.":
    "حالة مرافق المطار لدى كل تخصص، من أحدث فحوصاته التفصيلية في فحص المرافق.",
  "Airside systems": "أنظمة جانب الطيران",
  "The meteorological stations, stands, runway holding positions and helipads, each read from the survey inventory and every job and finding open against it. A P1 job weighs most; an open finding next.":
    "محطات الأرصاد والمواقف ونقاط الانتظار على المدرج ومهابط المروحيات، كلٌّ مقروء من سجل المسح وكل عمل وملاحظة مفتوحة عليه. أمر العمل P1 هو الأثقل وزنًا، ثم الملاحظة المفتوحة.",
  /* the cards moved from the Safety view to the top of Instruments (2026-10-03) */
  "Weather, radar and airside readiness": "الطقس والرادار وجاهزية الجانب الجوي",
  "read first: what the sky is doing, what is coming on the radar, and whether the airside is ready":
    "تُقرأ أولاً: حال الطقس، وما يقترب على الرادار، وهل الجانب الجوي جاهز",
  "The weather feed: the observation and the forecast for the aerodrome.": "تغذية الطقس: الرصد والتوقعات للمطار.",
  "The weather radar product: cell positions, intensity and track, carried forward from the observation.":
    "ناتج رادار الطقس: مواقع الخلايا وشدتها ومسارها، مُمدّدة من وقت الرصد.",
  "The day's airside patrols, closures, visual aids and friction verification, from the records.":
    "دوريات الجانب الجوي لليوم، والإغلاقات، والمساعدات البصرية، والتحقق من الاحتكاك، من السجلات.",
  "Bar meters · airside systems": "مقاييس شريطية · أنظمة جانب الطيران",
  "Bar meters · facility condition": "مقاييس شريطية · حالة المرافق",
  "MET instruments": "أجهزة الأرصاد",
  "{n} station|{n} stations": "لا محطات|محطة واحدة|محطتان|{n} محطات|{n} محطة|{n} محطة",
  "{n} stand|{n} stands": "لا مواقف|موقف واحد|موقفان|{n} مواقف|{n} موقفًا|{n} موقف",
  "{n} position|{n} positions": "لا نقاط|نقطة واحدة|نقطتان|{n} نقاط|{n} نقطة|{n} نقطة",
  "{n} helipad|{n} helipads": "لا مهابط|مهبط واحد|مهبطان|{n} مهابط|{n} مهبطًا|{n} مهبط",
  "The windsleeves and anemometers in the survey inventory, and every job and finding open against them.":
    "أكمام الرياح ومقاييس سرعة الرياح في سجل المسح، وكل عمل وملاحظة مفتوحة عليها.",
  "The aircraft stands in the survey inventory, and every job and finding open against them — markings, surface and equipment.":
    "مواقف الطائرات في سجل المسح، وكل عمل وملاحظة مفتوحة عليها — العلامات والسطح والمعدات.",
  "The runway holding positions in the survey inventory, and every job and finding open against them.":
    "نقاط الانتظار على المدرج في سجل المسح، وكل عمل وملاحظة مفتوحة عليها.",
  "The helipads in the survey inventory, and every job and finding open against them.":
    "مهابط المروحيات في سجل المسح، وكل عمل وملاحظة مفتوحة عليها.",
  /* ── Instruments: the tri gauge — RFF, security and access gates ── */
  "Cat {a}/{d} · response {r}s · crew {c}/{q}": "الفئة {a}/{d} · الاستجابة {r} ث · الطاقم {c}/{q}",
  "{level} · {n} active threats": "{level} · {n} تهديدات نشطة",
  "{n} breaches open · {f}/{r} readers faulty": "{n} اختراقات مفتوحة · {f}/{r} قارئات معطلة",
  "{feed} feed · {state}": "تغذية {feed} · {state}",
  "Read from the {feed} feed; the weakest part governs.": "مقروء من تغذية {feed}؛ والجزء الأضعف هو الحاكم.",
  "condition {c}": "الحالة {c}",
  "no feed": "بلا تغذية",
  "Its feed is not connected, so this reads the records the platform holds: the condition of {what} from their facility inspections, the jobs open against them, and the incidents logged about them.":
    "تغذيته غير موصولة، لذا يقرأ السجلات التي تحتفظ بها المنصة: حالة {what} من فحوصات مرافقها، والأعمال المفتوحة عليها، والحوادث المسجلة بشأنها.",
  "RFF, security and access": "الإنقاذ والإطفاء والأمن والدخول",
  "Rescue and fire fighting, security, and the aerodrome's access gates.": "الإنقاذ ومكافحة الحرائق، والأمن، وبوابات الدخول إلى المطار.",
  "Rescue and fire fighting, security, and the aerodrome's access gates — each from its own system when connected; until then from the stations' and gates' inspections, open jobs and incidents, marked no feed.":
    "الإنقاذ ومكافحة الحرائق، والأمن، وبوابات الدخول إلى المطار — كلٌّ من نظامه عند ربطه؛ وإلى ذلك الحين من فحوصات المحطات والبوابات والأعمال المفتوحة والحوادث، مع وسم «بلا تغذية».",
  "Tri gauge · RFF, security and access": "ثلاثة مؤشرات · الإنقاذ والإطفاء والأمن والدخول",
  RFF: "الإنقاذ والإطفاء",
  "Access gates": "بوابات الدخول",
  normal: "عادي",
  heightened: "مرتفع",
  threat: "تهديد",
  "the two fire stations, F03 ARFF and F29 Sub ARFF": "محطتي الإطفاء، F03 ومحطة F29 الفرعية",
  "the Guard House, F10": "مبنى الحراسة، F10",
  "the airside–landside gate F08 and the Monumental Gateway F09": "بوابة جانب الطيران والجانب الأرضي F08 والبوابة التذكارية F09",
  "Gauges · surface": "مؤشرات · حالة السطح",
  "The surface conditions as dials: FOD, wildlife, spills and sweeping, each as a proportion of clear.":
    "حالات السطح كمؤشرات: الأجسام الغريبة والحياة الفطرية والانسكابات والكنس، كلٌّ كنسبة من الخلو.",
};
export default ar;
